// The reader's clock against a club's (utils/clubClock): the device zone is read once the page is in the browser, so a
// server render carries no label and the hydrated page adds one only for a reader who is away.
import {computed, onMounted, ref} from 'vue';
import {awayLabel, clockNote, deviceZoneId, yourTimeLine} from '~/utils/clubClock';

const deviceZone = ref(null);
let mounted = false;

export function useClubClock() {
  onMounted(() => {
    if (!mounted) { mounted = true; deviceZone.value = deviceZoneId(); }
  });
  return {
    deviceZone: computed(() => deviceZone.value),
    /** "UK time" after a single headline time, only when away. */
    awayLabelFor: (instant, zone, label = null) => awayLabel(instant, zone, {deviceZone: deviceZone.value, label}),
    /** "Times are in UK time" for a screen whose times come from one club, only when away. */
    noteFor: (zone, instants = [], label = null) => clockNote(zone, instants, {deviceZone: deviceZone.value, label}),
    yourTime: (instant) => yourTimeLine(instant, deviceZone.value),
  };
}
